export const getReleaseNotes = (state) => state.releaseNotes.releaseNotes;
export const getHasAccess = (state) => state.releaseNotes.hasAccess;
export const getCanSendReleaseNoteEmails = (state) => state.releaseNotes.canSendReleaseNoteEmails;
export const getSavingStatuses = (state) => state.releaseNotes.savingStatuses;
export const getLoadingStatuses = (state) => state.releaseNotes.loadingStatuses;
export const getErrors = (state) => state.releaseNotes.errors;
